module.exports = __webpack_public_path__ + "static/media/strongher12.ac2fb94e.jpg";